import { render } from "./jobCategory.vue?vue&type=template&id=70f6bfde&scoped=true&ts=true"
import script from "./jobCategory.vue?vue&type=script&lang=ts"
export * from "./jobCategory.vue?vue&type=script&lang=ts"

import "./jobCategory.vue?vue&type=style&index=0&id=70f6bfde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f6bfde"]])

export default __exports__